import { STORAGE_KEY } from "@constants";
import { TFunction } from "i18next";
import { APIErrorCodes, ErrorResponse, QueryError } from "kz-ui-sdk";

const getErrorMessage = (lang: string, retryAfter: number | null, t: TFunction): string => {
  if (retryAfter !== null) {
    const minutes = Math.floor(retryAfter / 60);
    const seconds = retryAfter % 60;
    return t(`please wait {{minutes}} and {{seconds}} before trying again`, {
      minutes,
      seconds,
    });
  }
  return t("SMS provider is not found");
};

export const resolveRegisterRequestError = (error: QueryError<ErrorResponse>, t: TFunction) => {
  const lang = localStorage.getItem(STORAGE_KEY.LANGUAGE) || "en";
  if (error?.data?.error?.message === "request rate limited.") {
    const retryAfter = +error?.data?.error?.errors?.["rateLimit"] - +error?.data?.error?.errors?.["diff"];
    return getErrorMessage(lang, retryAfter, t);
  }

  // Map register error message
  switch (error?.data?.error?.message) {
    case APIErrorCodes.Auth.AccountSuspended:
    case APIErrorCodes.Auth.AccountClosed:
    case APIErrorCodes.Auth.AccountFrozen:
      return t("Request failed, please contact customer service.");
    case APIErrorCodes.Auth.CredentialsTempLocked:
    case APIErrorCodes.Auth.CredentialsTempBlocked: {
      const remainingTime = error?.data?.error?.errors?.remaining as unknown as number;
      const minutes = Math.floor(remainingTime / 60);
      const seconds = remainingTime % 60;

      return t("try again in {{minutes}} and {{seconds}}.", { minutes, seconds });
    }
    default:
      return t(error?.data?.error?.message ?? "An error occurred");
  }
};
